document.addEventListener('shoptet.products.sameHeightOfProducts', function() {
    productColors()
    
});
function productColors() {
    const productsData = JSON.parse(sessionStorage.getItem('dataImages'));
    if (productsData) {
        $('.products .product').each(function() {     
            if($(this).hasClass('highlight-product')){
                $(this).removeClass('highlight-product col-sm-12 col-md-8').addClass('col-xs-12 col-sm-6 col-md-4');
                $(this).find('.img img').attr('src', $(this).find('.img img').attr('data-src').replace('big', 'detail'))
            }    
            const productId = $(this).find('.img a').attr('href');
            const productDataStore = productsData.find(item => item.url.replace('https://www.zlatnictvisalaba.cz', '') === productId);
            if (productDataStore) {
                $(this).find('.img img').addClass('swap-image')
                $(this).find('.img img').attr('data-next', 'https://cdn.myshoptet.com/usr/www.zlatnictvisalaba.cz/user/shop/detail'+productDataStore.img_alt)
            }
        });
    }
    else{
        $.getJSON('/user/documents/dataImages.json', function(data) {
            sessionStorage.setItem('dataImages', JSON.stringify(data.product));
            $('.products .product').each(function() {     
                if($(this).hasClass('highlight-product')){
                    $(this).removeClass('highlight-product col-sm-12 col-md-8').addClass('col-xs-12 col-sm-6 col-md-4');
                    $(this).find('.img img').attr('src', $(this).find('.img img').attr('data-src').replace('big', 'detail'))
                }    
                const productId = $(this).find('.img a').attr('href');
                const productDataStore = data.product.find(item => item.url.replace('https://www.zlatnictvisalaba.cz', '') === productId);
                if (productDataStore) {
                    $(this).find('.img img').addClass('swap-image')
                    $(this).find('.img img').attr('data-next', 'https://cdn.myshoptet.com/usr/www.zlatnictvisalaba.cz/user/shop/detail'+productDataStore.img_alt)
                }
            });
        }).fail(function(jqxhr, textStatus, error) {
            console.error('Chyba při načítání JSON souboru:', textStatus, error);
        });
    }
}


$(document).on("mouseenter", '.product .img', function() {
    var img = $(this).find(".swap-image");
    if(img.attr('data-next')) {
        img.attr('src', img.attr('data-next'));
    }
}).on("mouseleave", '.product .img', function() {
    var img = $(this).find(".swap-image");
    if(img.attr('data-next')) {
        img.attr('src', img.attr('data-src'));
    }
});